import { useFormContext, UseFormReturn } from 'react-hook-form';

import { AppError } from '@/utils';

import { DashboardForm } from '.';

export const useDashboardFormContext = ():
  | UseFormReturn<DashboardForm>
  | never => {
  const form = useFormContext<DashboardForm>();

  if (form === null)
    throw AppError.hookScopeError(
      'useDashboardFormContext can only be used inside a Dashboard Form Context Provider.',
    );

  return form;
};
